import { type ProductOfferFragment } from '@/services/graphql/generated'
import { type Formatter } from '@/utils/formatter'
import { getBundleDiscountOnCurrentOffer } from '../bundleDiscount/bundleDiscount.utils'

type PriceMatchOffer = Pick<ProductOfferFragment, 'cost' | 'priceMatch'>

export function getPriceMatchYearlySavings(offer: PriceMatchOffer, formatter: Formatter) {
  if (!hasSuccessfullyPriceMatched(offer)) return null

  const priceMatchMonthlyReduction = offer.priceMatch.priceReduction.amount
  const currencyCode = offer.priceMatch.priceReduction.currencyCode

  // To make things more attractive, we also include bundle discount yearly savings
  // into the yearly reduction in case bundle discount is being applied to the selected offer.
  // We use Math.abs because discount amounts are represented as negative values in the API.
  const bundleDiscountMonthlyReduction = Math.abs(getBundleDiscountOnCurrentOffer(offer)?.amount.amount ?? 0)

  return formatter.annualReduction({
    amount: priceMatchMonthlyReduction + bundleDiscountMonthlyReduction,
    currencyCode,
  })
}

function hasSuccessfullyPriceMatched(
  offer: PriceMatchOffer,
): offer is PriceMatchOffer & { priceMatch: NonNullable<ProductOfferFragment['priceMatch']> } {
  return offer.priceMatch != null && offer.priceMatch.priceReduction.amount > 0
}
